import React, { Component } from 'react'
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import {
  Button, FormGroup, Checkbox, DateTimePicker,
  Intent, Spinner, RadioGroup, Radio, Dialog, Classes, Icon
} from "@blueprintjs/core";
import Toast from 'helpers/toaster';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import BookingDateTimeInput from 'components/BookingDateTimeInput';
import moment from 'moment';
import GeoComplete from '../../helpers/GeoComplete';
import { currencySymbol, currencyFormattedAmount } from 'helpers/currency';
import QuestionRadio from 'components/Booking/QuestionRadio';
import QuestionSelect from 'components/Booking/QuestionSelect';
import QuestionTextbox from 'components/Booking/QuestionTextbox';
import $ from 'jquery';
import { hasGroupedQuestions, joinAddress } from 'components/Booking/BookingLayout';
import BookingStepper from 'components/BookingModal/Stepper';
import { ChoiceGroup, ChoiceCard } from 'components/BookingModal/ChoiceCards';
import { normalizeHex } from 'helpers/serviceTypeColor';
import { bookingReference } from 'helpers/bookingReference';
import { flatOptionLabel, flatOptionQuantity } from 'helpers/bookingPricing';
import { CARD_PAYMENT_METHOD, cardCharge, cardPaymentsAvailable, isRecurringFrequency, payPublicBooking, paymentErrorMessage, recurringFrequencyChosen } from 'helpers/bookingCardPayment';
import BookingCardPayment from 'components/Booking/BookingCardPayment';

var startCountRange = 0
var label = '';
var indexChecked = '';
var selectedAnswer = '';
var url_string = window.location.href;
var url = new URL(url_string);
var is_brand = url.searchParams.get("is_brand");
var princingRangeCombineArray = [];

const items = [
  { label: 'Cash', value: 'Cash' },
  { label: 'Interac', value: 'Interac' },
  { label: 'Cheque', value: 'Cheque' },
  { label: 'Debit/Credit', value: 'dr/cr' }
];

// One entry per bookingStep (1-7), in order. Styles: styles/booking-modal.scss
// (.bk-modal) plus the .bk-public-modal additions in styles/booking-public.scss.
const MODAL_STEPS = [
  { label: 'Category', title: 'What do you need help with?', help: 'Pick a category to see its services.' },
  { label: 'Service', title: 'Choose a service', help: 'Pick the service you would like to book.' },
  { label: 'Details', title: 'Service details', help: 'Tell us a little more so we can estimate the price.' },
  { label: 'Your info', title: 'Your details', help: 'How we can reach you about this booking.' },
  { label: 'Address', title: 'Service address', help: 'Where should we do the work?' },
  { label: 'Schedule', title: 'Schedule', help: 'Add-ons, a few questions, and when you would like us to come.' },
  { label: 'Finish', title: 'Almost done', help: 'Add a photo or a note if it helps, then confirm.' },
];

// Tenant booking colour as the custom properties booking-modal.scss reads
// (--bk-ring is a bare colour there). Falls back to the default brand blue.
const modalBrandStyle = (color) => {
  const hex = normalizeHex(color) || '#1800FF';
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.substr(i, 2), 16));
  return {
    '--bk-brand': hex,
    '--bk-brand-tint': `rgba(${r}, ${g}, ${b}, 0.1)`,
    '--bk-ring': `rgba(${r}, ${g}, ${b}, 0.18)`,
  };
};
@inject('bookingStore', 'preferenceStore', 'serviceTypeStore', 'pricingParameterStore', 'frequencyStore', 'questionGroupStore', 'store', 'viewStore','serviceTypeCategoryStore') @observer
class BookingNewPublicModalPage extends Component {

  @observable pricingParameterArray = [];

  constructor(props) {
    super(props);
    this.state = {
      isServiceTypeChecked: 0,
      isPaymentSelect: 0,
      isFrequencySelected: null
    };
  }

  @observable startCountRange = 0;
  @observable extra_service_total = 0;
  @observable pricing_parameter_total = 0;
  @observable pricing_range_total = 0;
  @observable grand_total = 0.0;
  @observable isServiceTypeChecked = 0;
  // Set once the booking is created: the modal then shows the confirmation.
  @observable createdBookingId = null;
  // Card payments: the booking created but not paid yet (retry pays this one,
  // never a new booking), the payment in flight, its error, and what was paid.
  @observable paymentBookingId = null;
  @observable isPaying = false;
  @observable paymentError = null;
  @observable paidAmountCents = null;
  // The card field handle ({ stripe, card, isComplete }) and payment progress
  // for paymentBookingId. Plain fields: Stripe objects must not be observable.
  cardApi = null;
  paymentProgress = {};

  componentDidMount() {
    let {
      serviceTypeStore,
      questionGroupStore,
      serviceTypeCategoryStore,
      bookingStore: {
        booking: {
          object
        }
      }
    } = this.props;

    if (object && object.attributes) {
      this.grand_total = object.attributes.total;
    }
    serviceTypeCategoryStore.loadServiceTypePublicCategories();
    questionGroupStore.loadPublicQuestionGroups();
    //serviceTypeStore.loadPublicServiceTypesBooking();
    this.props.bookingStore.loadPublicPaymentSettings().catch(() => {});
    window.$crisp.push(['do', 'chat:hide']);
   
  }

  onAddressSelect(suggestion) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    if (suggestion) {
      object.attributes.address = suggestion.label;
      suggestion.gmaps && suggestion.gmaps.address_components && suggestion.gmaps.address_components.length > 0 && suggestion.gmaps.address_components.map((address_component) => {
        if (_.includes(address_component.types, "locality")) {
          object.attributes.city = address_component.long_name;
        }

        if (_.includes(address_component.types, "administrative_area_level_1")) {
          object.attributes.state = address_component.long_name;
        }

        if (_.includes(address_component.types, "postal_code")) {
          object.attributes.zip = address_component.long_name;
        }
      })
    } else {
      object.attributes.address = '';
      object.attributes.zip = "";
      object.attributes.state = "";
      object.attributes.city = "";
    }
  }

  onAddressClear(value) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    if (!value) {
      object.attributes.address = '';
    }
  }

  onExtraServiceSelect(event, selectedOptions, key) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;

    let index = object.attributes.booking_service_type_extras.map(function (item) { return item.name; }).indexOf(selectedOptions.name);
    if (event.target.checked === true) {
      if (index === -1) {
        object.attributes.booking_service_type_extras.push({ service_type_extra_id: selectedOptions.id, name: selectedOptions.name, price: parseFloat(selectedOptions.price_cents / 100) });
      } else {
        object.attributes.booking_service_type_extras[index].price = parseFloat(selectedOptions.price_cents / 100);
        object.attributes.booking_service_type_extras[index]._destroy = 0;
      }
    } else {
      object.attributes.booking_service_type_extras[index].price = 0;
      object.attributes.booking_service_type_extras[index]._destroy = 1;
    }
    this.calculateGrandtotal()
  }

  onFrequencySelect(event, selectedOptions, key) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    object.attributes.frequency_id = selectedOptions.id;
    // Cards are for one-time bookings only.
    if(isRecurringFrequency(selectedOptions) && object.attributes.payment_method === CARD_PAYMENT_METHOD) {
      object.attributes.payment_method = null;
    }
    this.setState({
      isFrequencySelected: key,
    });
  }

  onPricingRangeSelect(event, selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    if (event.target.value != '') {
      let index = object.attributes.booking_pricing_parameters.map(function (item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if (index > -1) {
        object.attributes.booking_pricing_parameters[index].pricing_parameter_id = selectedOptions.id;
        object.attributes.booking_pricing_parameters[index].name = event.target.options[event.target.selectedIndex].text;
        object.attributes.booking_pricing_parameters[index].price = parseFloat(event.target.value);
        object.attributes.booking_pricing_parameters[index].total_amount = parseFloat(event.target.selectedIndex) * parseFloat(event.target.value);

      } else {
        object.attributes.booking_pricing_parameters.push({ pricing_parameter_id: selectedOptions.id, name: event.target.options[event.target.selectedIndex].text, price: parseFloat(event.target.value), total_amount: parseFloat(event.target.value) });

      }
      this.calculateGrandtotal()
    }
  }

  onPricingRangeSelectImage(event,selectedOptions,key) { 
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.pricing_parameter_id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].pricing_parameter_id = selectedOptions.pricing_parameter_id;
        object.attributes.booking_pricing_parameters[index].name = selectedOptions.label;
        object.attributes.booking_pricing_parameters[index].price = selectedOptions.price;
        object.attributes.booking_pricing_parameters[index].total_amount =  selectedOptions.price;
      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.pricing_parameter_id,name:selectedOptions.label,price:selectedOptions.price,total_amount:selectedOptions.price});
      }
      this.calculateGrandtotal()
    
  }

  onPricingSelect(event, selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    if (event.target.value != '') {
      // Quantity is the number in the option label ("Tires x 4" is 4), as the server prices it.
      const quantity = flatOptionQuantity(flatOptionLabel(event));
      const amount = quantity * parseFloat((selectedOptions.price_cents / 100));
      let index = object.attributes.booking_pricing_parameters.map(function (item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if (index > -1) {
        object.attributes.booking_pricing_parameters[index].name = event.target.value;
        object.attributes.booking_pricing_parameters[index].price = amount;
        object.attributes.booking_pricing_parameters[index].quantity = quantity;
        object.attributes.booking_pricing_parameters[index].total_amount = amount;
      } else {
        object.attributes.booking_pricing_parameters.push({ pricing_parameter_id: selectedOptions.id, name: event.target.value, quantity: quantity, total_amount: amount, price: amount });
      }
    } else {
      object.pricing_parameters = [];
    }
    this.calculateGrandtotal()
  }

  // The saved choice for a flat pricing parameter (e.g. "Tires x 3"), so its
  // select shows it. Saved bookings keep choices in booking_pricing_parameters,
  // new ones in pricing_parameters; both store the option text as `name`.
  selectedPricingLabel(pricing) {
    const { object } = this.props.bookingStore.booking;
    const attributes = (object && object.attributes) || {};
    // Option text has its whitespace collapsed by the browser (a name like
    // "Tires x " gives "Tires x  4" in code but "Tires x 4" as the option and
    // as the saved name), so compare and return the collapsed form.
    const tidy = (text) => String(text || '').replace(/\s+/g, ' ').trim();
    const saved = [...(attributes.booking_pricing_parameters || []), ...(attributes.pricing_parameters || [])]
      .map((item) => item && tidy(item.name));
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      const label = tidy(`${pricing.name} ${i}`);
      if (saved.includes(label)) return label;
    }
    return '';
  }

  pricingList = (pricing) => {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    let pricingToReturn = [];
    this.pricingParameterArray = [];
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      let label = `${pricing.name} ${i}`;
      let indexChecked = object.attributes.booking_pricing_parameters.map(function (item) { return item.name; }).indexOf(label);
      if (indexChecked > -1) {
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      } else {
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }
    }
    return pricingToReturn;
  };

  pricingRangeList = (pricing) => {
    let {
      props: {
        pricingParameterStore,
        pricingParameterStore: {
          pricingParameterDetailUpdate: {
            object
          }
        },
        bookingStore: {
          booking
        }
      }
    } = this;
    let pricingRangeToReturn = [];

    if (pricing.id) {
      let index = pricing.pricing_parameter_ranges.map(function (item) { return item.pricing_parameter_id; }).indexOf(pricing.id);
      if (index > -1) {
        pricing.pricing_parameter_ranges.map((range) => {
          let label = `${range.label}`;
          let indexChecked = booking.object.attributes.booking_pricing_parameters.map(function (item) { return item.name; }).indexOf(label);
          if (indexChecked > -1) {
            pricingRangeToReturn.push(<option selected={'selected'} innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          } else {
            pricingRangeToReturn.push(<option innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          }
        });
      }
    }
    return pricingRangeToReturn;
  };

  handleStartDateChange(date) {
    let { object } = this.props.bookingStore.booking;
    if (date) {
      object.attributes.start_date = moment(date);
    }
  }

  onPaymentSelect = (event, payment, key) => {
    let { object } = this.props.bookingStore.booking;
    // The booking is already saved for a card payment: keep the choice.
    if (this.paymentBookingId || this.isPaying) return;
    this.paymentError = null;
    // Highlight the chosen option (it stayed on the first one).
    this.setState({
      isPaymentSelect: key,
    });
    object.attributes.payment_method = payment.value;
  }

  onServiceTypeChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore } = this.props;
    let {
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    if (event.target.value !== "") {
      princingRangeCombineArray = [];
      this.isServiceTypeChecked = event.target.value;
      object.attributes.booking_service_type_extras = [];
      object.attributes.booking_pricing_parameters = [];
      object.attributes.service_type_id = event.target.value;
      serviceTypeStore.loadPublicServiceTypeDetail({ uuid: event.target.value })
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    } else {
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  onServiceTypeCategoryChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    this.props.viewStore.serviceTypeSearch.where.service_type_category_id = event;
    this.props.serviceTypeStore.loadPublicServiceTypesBooking() 
    object.attributes.service_type_category_id = event;
  }

  onServiceTypeSelect = (event, service, key) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore } = this.props;
    let {
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    if (service.attributes.id !== "") {
      this.isServiceTypeChecked = service.attributes.id;
      princingRangeCombineArray = [];
      object.attributes.booking_service_type_extras = [];
      object.attributes.booking_pricing_parameters = [];
      object.attributes.service_type_id = service.attributes.id;
      serviceTypeStore.loadPublicServiceTypeDetail({ uuid: service.attributes.id })
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    } else {
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  calculateGrandtotal() {
    let {
      bookingStore: {
        booking: {
          object
        }
      },
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;

    object.attributes.total = 0.0;

    // Adding Service type price in grand total
    if (serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      object.attributes.total += serviceTypeDetail.object.attributes.rate;
    }

    // Adding pricing parameters flat/ranges to grand total
    if (object && object.attributes.booking_pricing_parameters && object.attributes.booking_pricing_parameters.length > 0) {
      object.attributes.total += _.sumBy(object.attributes.booking_pricing_parameters, 'price')
    }

    // Adding extra service types to grand total
    if (object && object.attributes.booking_service_type_extras && object.attributes.booking_service_type_extras.length > 0) {
      object.attributes.total += _.sumBy(object.attributes.booking_service_type_extras, 'price')
    }
  }

  createBooking() {
    let {
      props: {
        store,
        bookingStore: {
          tenant,
          booking,
          booking: {
            object
          }
        }
      }
    } = this;

    if (this.isPaying) return;
    // The booking already exists and is waiting for its card payment: pay
    // that one again instead of creating a second booking.
    if (this.paymentBookingId) {
      this.retryPayment();
      return;
    }

    if (object.attributes.first_name === "" || object.attributes.first_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
      return;
    }
    if (object.attributes.last_name === "" || object.attributes.last_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
      return;
    }
    if (object.attributes.email === "" || object.attributes.email === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
      return;
    }
    if (object.attributes.phone === "" || object.attributes.phone === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
      return;
    }
    if (object.attributes.address === "" || object.attributes.address === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
      return;
    }
    if (object.attributes.city === "" || object.attributes.city === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
      return;
    }
    if (object.attributes.state === "" || object.attributes.state === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
      return;
    }
    if (object.attributes.zip === "" || object.attributes.zip === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
      return;
    }
    if (object.attributes.service_type_id === "" || object.attributes.service_type_id === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please select service type!', intent: Intent.DANGER })
      return;
    }
    // if (object.attributes.frequency_id === "" || object.attributes.frequency_id === 0) {
    //   Toast.show({ icon: 'warning-sign', message: 'Please select frequency!', intent: Intent.DANGER })
    //   return;
    // }
    // if (object.attributes.payment_method === "" || object.attributes.payment_method === null) {
    //   Toast.show({ icon: 'warning-sign', message: 'Please select payment method!', intent: Intent.DANGER })
    //   return;
    // }

    // Paying by card: the card must be filled in before the booking is sent.
    const payByCard = this.isCardPayment();
    if (payByCard) {
      if (!this.cardApi) {
        this.paymentError = 'The card field is still loading. Please wait a moment and try again.';
        return;
      }
      if (!this.cardApi.isComplete()) {
        this.paymentError = 'Enter your full card details.';
        Toast.show({ icon: 'warning-sign', message: 'Enter your full card details.', intent: Intent.DANGER });
        this.cardApi.focus();
        return;
      }
      this.paymentError = null;
      this.isPaying = true;
    }

    object.attributes.booking_service_type_extras_attributes = object.attributes.booking_service_type_extras;
    object.attributes.booking_pricing_parameters_attributes = object.attributes.booking_pricing_parameters;
    object.attributes.status = 'draft';
    object.attributes.booking_questions_attributes = object.attributes.booking_questions;

    this.props.bookingStore
      .createPublicBooking(object)
      .then(response => {
        const created = response && response.data && response.data.data;
        const createdId = (created && (created.id || (created.attributes && created.attributes.id))) || true;
        if (payByCard && createdId !== true) {
          this.paymentBookingId = createdId;
          this.paymentProgress = {};
          this.runPayment(createdId);
          return;
        }
        if (payByCard) {
          // No booking id came back, so there is nothing to charge.
          this.isPaying = false;
          Toast.show({ icon: 'warning-sign', message: 'Your booking was sent, but we couldn\'t take the card payment. We\'ll be in touch about paying.', intent: Intent.WARNING });
        } else {
          Toast.show({
            icon: "thumbs-up",
            message: 'Thanks, your booking was sent.',
            intent: Intent.SUCCESS
          });
        }
        store.isBookingConfirmDialog = true;
        this.createdBookingId = createdId;
      })
      .catch((error) => {
        this.isPaying = false;
        const message = (error && error.response && error.response.data && (error.response.data.errors || error.response.data.error)) || 'Your booking wasn\'t sent. Check your details and try again.';
        Toast.show({ icon: 'warning-sign', message: Array.isArray(message) ? message.join(', ') : String(message), intent: Intent.DANGER });
      });
  }

  // Card chosen, and the company takes cards.
  isCardPayment() {
    const { bookingStore } = this.props;
    const attributes = bookingStore.booking.object && bookingStore.booking.object.attributes;
    return Boolean(attributes && attributes.payment_method === CARD_PAYMENT_METHOD && cardPaymentsAvailable(bookingStore.paymentSettings));
  }

  // Charges the saved booking: payment_intent, Stripe confirmation, then
  // payment_confirmation. On failure the booking stays saved for a retry.
  runPayment(bookingId) {
    const { bookingStore, store } = this.props;
    this.isPaying = true;
    this.paymentError = null;
    payPublicBooking(bookingStore, this.cardApi, bookingId, this.paymentProgress)
      .then(({ amountCents }) => {
        this.isPaying = false;
        this.paidAmountCents = amountCents != null ? amountCents : null;
        this.paymentBookingId = null;
        Toast.show({ icon: "thumbs-up", message: 'Payment received. Thanks, your booking was sent.', intent: Intent.SUCCESS });
        store.isBookingConfirmDialog = true;
        this.createdBookingId = bookingId;
      })
      .catch((error) => {
        this.isPaying = false;
        this.paymentError = paymentErrorMessage(error);
        Toast.show({ icon: 'warning-sign', message: 'Your booking is saved, but the payment didn\'t go through.', intent: Intent.DANGER });
      });
  }

  onCardReady = (api) => {
    this.cardApi = api;
  }

  onCardChange = (change) => {
    // A complete card clears the "enter your card" message (not a payment error).
    if (change.complete && !this.paymentBookingId) this.paymentError = null;
  }

  retryPayment() {
    if (!this.paymentBookingId || this.isPaying) return;
    if (!this.paymentProgress.charged && !(this.cardApi && this.cardApi.isComplete())) {
      this.paymentError = 'Enter your full card details.';
      if (this.cardApi) this.cardApi.focus();
      return;
    }
    this.runPayment(this.paymentBookingId);
  }

  onChangeFile(event) {
    let {
      bookingStore: {
        booking: {
          object: { attributes }
        }
      }
    } = this.props;
    if(event.target.files[0]){
      var FileSize = event.target.files[0].size / 1024 / 1024; // in MB
      if (FileSize > 10) {
        Toast.show({ icon: 'warning-sign', message: 'File size exceeds 10 MB!', intent: Intent.DANGER })
        return
      }
      this.props.bookingStore.uploadPublicBookingAttachment(event.target.files[0], attributes.id)
        .then(this.onSuccessfullUploadAttachment.bind(this))
        .catch(this.onFailUploadAttachment.bind(this))
    }else{
      Toast.show({ icon: 'warning-sign', message: 'Please choose from gallery!', intent: Intent.DANGER })
      return
    }
    
  }

  onSuccessfullUploadAttachment(response) {
    let {
      bookingStore: {
        booking: {
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.booking_attachment_ids.push(response.data.data.attributes.id);
    attributes.booking_attachments.push(response.data.data.attributes);
  }

  onFailUploadAttachment(error) {
    if (error.response && error.response.data && error.response.data.errors) {
      Toast.show({ icon: 'warning-sign', message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ icon: 'warning-sign', message: 'Something went wrong, please choose from gallery!', intent: Intent.DANGER })
    }
  }

  removeAttachment(attachment) {
    let {
      bookingStore: {
        booking: {
          object: { attributes }
        }
      }
    } = this.props;
    this.props.bookingStore.removePublicAttachment(attachment, attributes.id)
  }

  validate(bookingStep) {
    let {
      props: {
        bookingStore,
        bookingStore: {
          booking,
          booking: {
            object
          }
        }
      }
    } = this;
    if (bookingStep === 4) {
      if (object.attributes.first_name === "" || object.attributes.first_name === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.last_name === "" || object.attributes.last_name === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.email === "" || object.attributes.email === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.phone === "" || object.attributes.phone === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if (bookingStep === 5) {
      if (object.attributes.address === "" || object.attributes.address === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.city === "" || object.attributes.city === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.state === "" || object.attributes.state === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.zip === "" || object.attributes.zip === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if (bookingStep === 1) {
      if(object.attributes.service_type_category_id === "" || object.attributes.service_type_category_id === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please select service type category!', intent: Intent.DANGER })
        return;
      }
      return true;
    }
    if (bookingStep === 2) {
      if (object.attributes.service_type_id === "" || object.attributes.service_type_id === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please select service type!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if (bookingStep === 6) {
      // if (object.attributes.frequency_id === "" || object.attributes.frequency_id === 0) {
      //   Toast.show({ icon: 'warning-sign', message: 'Please select frequency!', intent: Intent.DANGER })
      //   return false;
      // }
      return true;
    }
    
    if (bookingStep === 3) {
      return true;
    }

  }

  navigateToNextScreen() {
    let {
      props: {
        bookingStore,
        bookingStore: {
          bookingStep,
          booking,
          booking: {
            object
          }
        }
      }
    } = this;
    
    $(window).scrollTop( $(".bp3-dialog-body").offset().top );

    let result = this.validate(bookingStore.bookingStep);
    if (bookingStep < 8 && result === true) {
      bookingStore.bookingStep1 = false;
      bookingStore.bookingStep2 = false;
      bookingStore.bookingStep3 = false;
      bookingStore.bookingStep4 = false;
      bookingStore.bookingStep5 = false;
      bookingStore.bookingStep6 = false;
      bookingStore.bookingStep7 = false;

      bookingStore.bookingStep = bookingStep + 1;

      switch (bookingStore.bookingStep) {
        case 1:
          bookingStore.bookingStep1 = true;
          break;
        case 2:
          bookingStore.bookingStep2 = true;
          break;
        case 3:
          bookingStore.bookingStep3 = true;
          break;
        case 4:
          bookingStore.bookingStep4 = true;
          break;
        case 5:
          bookingStore.bookingStep5 = true;
          break;
        case 6:
          bookingStore.bookingStep6 = true;
          break;
        case 7:
          bookingStore.bookingStep7 = true;
          break;
        default:
        // code block
      }
    }
  }

  navigateToPreviousScreen() {
    let {
      bookingStore,
      bookingStore: {
        bookingStep
      }
    } = this.props;

    $(window).scrollTop( $(".bp3-dialog-body").offset().top );

    if (bookingStep > 1) {
      bookingStore.bookingStep = bookingStep - 1;

      bookingStore.bookingStep1 = false;
      bookingStore.bookingStep2 = false;
      bookingStore.bookingStep3 = false;
      bookingStore.bookingStep4 = false;
      bookingStore.bookingStep5 = false;
      bookingStore.bookingStep6 = false;
      bookingStore.bookingStep7 = false;
      switch (bookingStore.bookingStep) {
        case 1:
          bookingStore.bookingStep1 = true
          break;
        case 2:
          bookingStore.bookingStep2 = true
          break;
        case 3:
          bookingStore.bookingStep3 = true
          break;
        case 4:
          bookingStore.bookingStep4 = true
          break;
        case 5:
          bookingStore.bookingStep5 = true
          break;
        case 6:
          bookingStore.bookingStep6 = true
          break;
        case 7:
          bookingStore.bookingStep7 = true
          break;
        default:
        // code block
      }
    }
  }

  handleCloseCopyDailog() {
    if(window.parent){
      window.parent.postMessage("closeModal", "*");
    }
  }

  handleSuccessCopyDailog() {
    this.props.onSuccess();
  }

  onTimePeriodChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.start_project_expected_period = event.target.value;
  }

  onContactWayChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.contact_way = event.target.value;
  }

  render() {
    let {
      store,
      serviceTypeStore: {
        serviceType,
        serviceType: {
          objects
        },
        serviceTypeDetail,
      },
      bookingStore: {
        bookingStep,
        bookingStep1,
        bookingStep2,
        bookingStep3,
        bookingStep4,
        bookingStep5,
        bookingStep6,
        bookingStep7,
        showUploadAttachmentLoader,
        tenant,
        tenant: {
          object
        },
        booking:{
          object: {
            attributes
          },
          isLoading
        }
      },
      questionGroupStore: {
        groups
      },
      serviceTypeCategoryStore:{
        serviceTypeCategories
      }
    } = this.props;

    let service_type_extra = [];
    let pricing_parameters = [];
    let frequency = [];
    let questions = [];

    if (serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      service_type_extra = serviceTypeDetail.object.attributes.service_type_extra
      pricing_parameters = serviceTypeDetail.object.attributes.pricing_parameters
      frequency = serviceTypeDetail.object.attributes.frequency
      questions = serviceTypeDetail.object.attributes.questions;
    }

    // In this render `object` is the tenant (booking form settings, texts and
    // colours) and `attributes` is the booking being created.
    const tenantAttributes = (object && object.attributes) || {};
    const showPrices = Boolean(tenantAttributes.enable_booking_price_display);
    const stepMeta = MODAL_STEPS[(bookingStep || 1) - 1] || MODAL_STEPS[0];
    const stepTitle = bookingStep === 2 && tenantAttributes.heading_text_for_service_type ? tenantAttributes.heading_text_for_service_type : stepMeta.title;
    const selectedService = serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes;
    const selectedServiceColor = selectedService ? normalizeHex(selectedService.color) : null;
    const startDate = attributes && attributes.start_date ? moment(attributes.start_date) : null;
    const hasStartDate = startDate && startDate.isValid();
    const customerName = attributes ? [attributes.first_name, attributes.last_name].filter((part) => part && String(part).trim() !== '').join(' ') : '';
    const pricingTitle = tenantAttributes.pricing_title ? tenantAttributes.pricing_title : 'Pricing';
    const pricingLines = attributes && attributes.booking_pricing_parameters ? attributes.booking_pricing_parameters : [];
    const extraLines = service_type_extra && service_type_extra.length > 0 && attributes && attributes.booking_service_type_extras
      ? attributes.booking_service_type_extras.filter((ext_service) => ext_service._destroy !== 1)
      : [];
    const confirmLabel = tenantAttributes.cta_title ? tenantAttributes.cta_title : 'Confirm booking';
    const createdReference = this.createdBookingId && this.createdBookingId !== true ? bookingReference(this.createdBookingId) : null;
    // Debit/Credit is offered only when the company takes cards online.
    const paymentSettings = this.props.bookingStore.paymentSettings;
    const cardsOn = tenantAttributes.payment_method === true && cardPaymentsAvailable(paymentSettings) && !recurringFrequencyChosen(frequency, attributes && attributes.frequency_id);
    const payByCard = Boolean(cardsOn && attributes && attributes.payment_method === CARD_PAYMENT_METHOD);
    // Paying by card: the company's default tax (HST...) is added and charged too.
    const charge = payByCard ? cardCharge(attributes && attributes.total, paymentSettings) : null;
    const awaitingPayment = Boolean(this.paymentBookingId);
    const totalLabel = payByCard ? 'Total (charged when you book)' : 'Estimated total';

    return (
      <Dialog
        className="bk-modal bk-public-modal"
        isOpen={true}
        isCloseButtonShown={false}
        onClose={this.handleCloseCopyDailog.bind(this)}
        style={modalBrandStyle(tenantAttributes.booking_form_color)}
        // While paying, Stripe may open its card check (3-D Secure) outside the
        // dialog: let focus go there, and don't let the modal close mid-charge.
        enforceFocus={!this.isPaying}
        canEscapeKeyClose={!this.isPaying}
        canOutsideClickClose={!this.isPaying}
      >
        <style dangerouslySetInnerHTML={{__html: `
          body{background-color: rgba(245, 247, 250, 0.4)!important;}
          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background-color: ${normalizeHex(tenantAttributes.booking_form_color) || '#1800FF'} !important;
          }
        `}} />
        <div className="bk-modal__header">
          {tenantAttributes.logo &&
            <span className="bk-modal__logo"><img src={tenantAttributes.logo} alt="" /></span>
          }
          <div className="bk-modal__heading">
            <h2 className="bk-modal__title">{tenantAttributes.booking_page_title ? tenantAttributes.booking_page_title : 'Book a service'}</h2>
            {tenantAttributes.name && <span className="bk-modal__tenant">{tenantAttributes.name}</span>}
          </div>
          <Button
            className="bk-modal__close"
            aria-label="Close"
            minimal={true}
            icon="cross"
            disabled={this.isPaying}
            onClick={() => this.handleCloseCopyDailog(this)}
          />
        </div>

        { this.createdBookingId ?
          <div className="bk-public-modal__success" role="status">
            <span className="bk-public-modal__success-check"><Icon icon="tick" iconSize={36} /></span>
            <h3 className="bk-public-modal__success-title">
              {tenantAttributes.booking_confirmation_message_title ? tenantAttributes.booking_confirmation_message_title : 'Thanks, your booking is in'}
            </h3>
            <p className="bk-public-modal__success-text">
              {tenantAttributes.booking_confirmation_message ? tenantAttributes.booking_confirmation_message : "We'll be in touch soon to confirm the details."}
            </p>
            <div className="bk-public-modal__success-meta">
              {createdReference && <span className="bk-public-modal__reference">Reference {createdReference}</span>}
              {showPrices && <span className="bk-public-modal__reference">Estimated total {currencyFormattedAmount(attributes && attributes.total)}</span>}
              {this.paidAmountCents != null && <span className="bk-public-modal__reference bk-public-modal__paid">Paid {currencyFormattedAmount(this.paidAmountCents / 100)}</span>}
            </div>
            <Button
              className="bk-btn bk-btn--secondary"
              onClick={() => this.handleCloseCopyDailog(this)}
              text="Close"
            />
          </div>
          :
          <React.Fragment>
            <BookingStepper steps={MODAL_STEPS.map((step) => step.label)} current={bookingStep || 1} />

            {/* .bp3-dialog-body is kept: Back / Continue scroll to it. */}
            <div className={`bk-modal__body ${Classes.DIALOG_BODY}`} style={{ margin: '0px' }}>
              <div className="bk-modal__main">
                <div className="bk-modal__content">
                  <div className="bk-modal__step-head">
                    <h3 className="bk-modal__step-title">{stepTitle}</h3>
                    <p className="bk-modal__step-help">{stepMeta.help}</p>
                  </div>
                  {
                    bookingStep1 === true ?
                      <div className="bk-modal__step">
                        <div className="bk-section">
                          <div className="bk-section__head">
                            <span className="bk-label">Category <span className="bk-required" aria-hidden="true">*</span></span>
                            { (serviceTypeCategories.objects.length === 0 || serviceType.isLoading) ?
                              <Spinner size={18} />
                              :
                              ""
                            }
                          </div>
                          {
                            serviceTypeCategories.objects &&
                            <ChoiceGroup label="Category" className="bk-choices bk-choices--compact">
                              { serviceTypeCategories.objects.map((category) => {
                                  return (
                                    <ChoiceCard
                                      key={category.id}
                                      className="bk-choice--category"
                                      checked={attributes.service_type_category_id === category.id}
                                      onSelect={() => { this.onServiceTypeCategoryChange(category.id) }}
                                    >
                                      <span className="bk-choice__check" aria-hidden="true"><Icon icon="tick" iconSize={10} /></span>
                                      <span className="bk-choice__name">{category.attributes.name}</span>
                                    </ChoiceCard>
                                  )
                                })
                              }
                            </ChoiceGroup>
                          }
                        </div>
                      </div>
                      : ''
                  }
                  { bookingStep2 === true ?
                    <div className="bk-modal__step">
                      <ChoiceGroup label="Service" className="bk-choices">
                        {attributes && attributes.service_type_category_id != '' && objects && objects.map((service, key) => {
                          if (service.attributes.display_on_booking_form) {
                            const checked = service.id === attributes.service_type_id ? true : false;
                            const accent = normalizeHex(service.attributes.color);
                            return (
                              <ChoiceCard
                                key={service.id || key}
                                className="bk-choice--service"
                                checked={checked}
                                style={accent ? { '--bk-service': accent } : undefined}
                                onSelect={(event) => { if (!checked) { this.onServiceTypeSelect(event, service, key) } }}
                              >
                                <span className="bk-choice__check" aria-hidden="true"><Icon icon="tick" iconSize={10} /></span>
                                {service.attributes.logo ?
                                  <span className="bk-choice__logo"><img src={service.attributes.logo} alt="" /></span>
                                  :
                                  <span className="bk-choice__dot" aria-hidden="true" />
                                }
                                <span className="bk-choice__name">{service.attributes.name}</span>
                              </ChoiceCard>
                            )
                          }
                        })
                        }
                      </ChoiceGroup>
                      {serviceType.isLoading && <Spinner size={18} />}
                    </div>
                    :''
                  }
                  {
                    bookingStep3 === true ?
                      <div className="bk-modal__step">
                        {(!pricing_parameters || pricing_parameters.length === 0) &&
                          <p className="bk-empty">No extra details needed for this service. Continue to the next step.</p>
                        }
                        {pricing_parameters && pricing_parameters.length > 0 && <div className="bk-section">
                          <div className="bk-grid">
                            {
                              pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing, pricingKey) => {
                                if (pricing.pricing_type === 'flat') {
                                  return (
                                    <div className="bk-field">
                                      <FormGroup label={pricing.name || "Pricing"} labelFor="text-input">
                                        <select
                      value={this.selectedPricingLabel(pricing)}
                                          className='bk-input'
                                          placeholder={`Select ${pricing.name}`}
                                          onChange={(event) => { this.onPricingSelect(event, pricing) }}
                                        >
                                          <option value="">Select one</option>
                                          {this.pricingList(pricing)}
                                        </select>
                                      </FormGroup>
                                    </div>
                                  )
                                }
                              })
                            }
                          </div>
                          <div className="bk-grid">
                            {
                              pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing) => {
                                if (pricing.pricing_type === 'range') {
                                  var index = pricing.pricing_parameter_ranges.length === _.filter(pricing.pricing_parameter_ranges, function(obj) { return obj.image_url }).length
                                  return (
                                    <div className={index === true ? 'bk-field bk-field--wide' : 'bk-field'}>
                                      <FormGroup
                                        label={pricing.name}
                                        labelFor="text-input"
                                        labelInfo={""}
                                        className="first-latter-capital"
                                      >
                                        {
                                          index === true ?
                                          <div className="bk-image-choices">
                                            {pricing.pricing_parameter_ranges.map((pricing_range,key) => {
                                              let indexChecked = attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(pricing_range.label);
                                              var checked_id ='';
                                              if(indexChecked > -1){
                                                checked_id = pricing_range.id;
                                              }
                                              return (
                                                <div className={`bk-image-choice${checked_id === pricing_range.id ? ' is-checked' : ''}`} key={pricing_range.id || key}>
                                                  <img src={pricing_range.image_url} alt="" onClick={(event) => {this.onPricingRangeSelectImage(event,pricing_range,key)} } />
                                                  <span className="bk-image-choice__foot">
                                                    <Radio type="radio" name="checkboxgroup"
                                                      aria-label={pricing_range.label}
                                                      checked={checked_id === pricing_range.id ? true: false}
                                                      onChange={(event) => {this.onPricingRangeSelectImage(event,pricing_range,key)} }
                                                    />
                                                    <span className="bk-image-choice__label">{pricing_range.label}</span>
                                                  </span>
                                                </div>
                                              )
                                            })}
                                          </div>:
                                          <select
                                            className='bk-input'
                                            placeholder={`Select ${pricing.name}`}
                                            onChange={(event) => {this.onPricingRangeSelect(event,pricing)} }
                                            >
                                            <option value="">Select one</option>
                                            { this.pricingRangeList(pricing)}
                                          </select>
                                        }
                                      </FormGroup>
                                    </div>
                                  )
                                }
                              })
                            }
                          </div>
                        </div>}
                      </div>
                      : ''
                  }
                  {
                    bookingStep4 === true ?
                      <div className="bk-modal__step">
                        <div className="bk-grid">
                          <div className="bk-field">
                            <FormGroup
                              label={"First name"}
                              labelFor="bk-first-name"
                              labelInfo={"*"}
                            >
                              <input
                                id="bk-first-name"
                                type='text'
                                className='bk-input'
                                placeholder='First name'
                                autoComplete="given-name"
                                defaultValue={attributes.first_name}
                                onChange={(event) => { attributes.first_name = event.target.value; }}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Last name"}
                              labelFor="bk-last-name"
                              labelInfo={"*"}
                            >
                              <input
                                id="bk-last-name"
                                type='text'
                                className='bk-input'
                                placeholder='Last name'
                                autoComplete="family-name"
                                defaultValue={attributes.last_name}
                                onChange={(event) => { attributes.last_name = event.target.value; }}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Email"}
                              labelFor="bk-email"
                              labelInfo={"*"}
                            >
                              <input
                                id="bk-email"
                                type='email'
                                className='bk-input'
                                placeholder='you@example.com'
                                autoComplete="email"
                                defaultValue={attributes.email}
                                onChange={(event) => { attributes.email = event.target.value; }}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Phone"}
                              labelFor="bk-phone"
                              labelInfo={"*"}
                            >
                              <input
                                id="bk-phone"
                                type='tel'
                                className='bk-input'
                                placeholder='Ex. 637543210'
                                autoComplete="tel"
                                defaultValue={attributes.phone}
                                onChange={(event) => { attributes.phone = event.target.value; }}
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {
                    bookingStep5 === true ?
                      <div className="bk-modal__step">
                        <div className="bk-grid">
                          <div className="bk-field bk-field--wide">
                            <FormGroup
                              label={"Address"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <GeoComplete
                                className='geo-control'
                                placeholder="Start typing your address"
                                initialValue={attributes.address}
                                onSuggestSelect={this.onAddressSelect.bind(this)}
                                onChange={this.onAddressClear.bind(this)}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field bk-field--wide">
                            <FormGroup
                              label={"Address line 2"}
                              labelFor="bk-suite"
                            >
                              <input
                                id="bk-suite"
                                type='text'
                                className='bk-input'
                                placeholder='Apartment, suite, unit'
                                autoComplete="address-line2"
                                defaultValue={attributes.suite}
                                onChange={(event) => { attributes.suite = event.target.value; }}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"City"}
                              labelFor="bk-city"
                              labelInfo={"*"}
                            >
                              <input
                                id="bk-city"
                                type='text'
                                className='bk-input'
                                placeholder='City'
                                autoComplete="address-level2"
                                value={(attributes.city) || ''}
                                onChange={(event) => { attributes.city = event.target.value; }}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"State or province"}
                              labelFor="bk-state"
                              labelInfo={"*"}
                            >
                              <input
                                id="bk-state"
                                type='text'
                                className='bk-input'
                                placeholder='State or province'
                                autoComplete="address-level1"
                                value={(attributes.state) || ''}
                                onChange={(event) => { attributes.state = event.target.value; }}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Zip or postal code"}
                              labelFor="bk-zip"
                              labelInfo={"*"}
                            >
                              <input
                                id="bk-zip"
                                type='text'
                                className='bk-input'
                                placeholder='Ex. 0377'
                                autoComplete="postal-code"
                                value={(attributes.zip) || ''}
                                onChange={(event) => { attributes.zip = event.target.value; }}
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {
                    bookingStep6 === true ?
                      <div className="bk-modal__step">
                        {service_type_extra && service_type_extra.length > 0 && <div className="bk-section">
                          <div className="bk-section__head">
                            <span className="bk-label">Add-ons <span className="bk-optional">Optional</span></span>
                          </div>
                          <div className="bk-public-modal__cards">
                            {
                              service_type_extra.map((extra,key) => {
                                indexChecked = attributes.booking_service_type_extras.map(function(item) { return item._destroy !== 1 ? item.service_type_extra_id : ""; }).indexOf(extra.id);
                                if(indexChecked > -1){
                                  label = extra.id;
                                } else {
                                  label = ""
                                }
                                return (
                                  <div className={`bk-public-modal__card ${label === extra.id ? 'is-checked' :''}`} key={Math.random()}>
                                    <span className="bk-public-modal__card-icon">
                                      {extra.icon_file && extra.icon_file.thumb && extra.icon_file.thumb.url && <img src={extra.icon_file.thumb.url} alt="" />}
                                    </span>
                                    <span className="bk-public-modal__card-label">{extra.name}</span>
                                    <Checkbox label="" type="checkbox"
                                      className="bk-public-modal__card-control"
                                      aria-label={extra.name}
                                      defaultChecked={label === extra.id ? true : false}
                                      onChange={(event) => {this.onExtraServiceSelect(event,extra,key)} }
                                    />
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>}
                        {hasGroupedQuestions(groups, questions) && <div className="bk-section">
                          <div className="bk-section__head">
                            <span className="bk-label">A few more details</span>
                          </div>
                          <div className="bk-public-modal__questions">
                          {
                            groups.objects.map(function(group) {
                              var isInGroup = questions.map(function(item) { return item.question_group_id; }).indexOf(group.id);
                              if(isInGroup > -1) {
                                return(
                                  <div className="bk-public-modal__question-group" key={group.id}>
                                    <p className="bk-public-modal__question-title">{group.attributes.question}</p>
                                    {questions && questions.length > 0 && questions.map((question, index) => {

                                      indexChecked = attributes.booking_questions.map(function(item) { return item.question_id; }).indexOf(question.id);
                                      if(indexChecked > -1){
                                        label = question.id;
                                        selectedAnswer = attributes.booking_questions[indexChecked].answer;
                                      } else {
                                        selectedAnswer = ""
                                      }
                                      if(group.attributes.id === question.question_group_id){
                                      return(
                                        <div className="bk-public-modal__question" key={question.id || index}>
                                          <span className="bk-label">{question.field_label}</span>
                                          <div className="bk-public-modal__answer">
                                            {question.field_type === "Checkbox" && <div>
                                              <RadioGroup inline={true} className="bk-public-modal__radios" name="question_radio">
                                                {question.field_value && question.field_value.split(/\r?\n/).map((answer) => {
                                                  return(
                                                    <QuestionRadio
                                                      key={Math.random()}
                                                      inline= {true}
                                                      bookingStatus={''}
                                                      question={question}
                                                      answer={answer}
                                                      checkedValue={label}
                                                      selectedAnswer={selectedAnswer}
                                                    />
                                                  )
                                                })}
                                              </RadioGroup>
                                              </div>}
                                              {question.field_type === "Dropdown"  && <div className="bk-public-modal__control">
                                                <QuestionSelect
                                                  inline= {true}
                                                  question={question}
                                                  bookingStatus={''}
                                                  checkedValue={label}
                                                  selectedAnswer={selectedAnswer}
                                                />
                                              </div>}
                                              {question.field_type === "Textbox"  && <div className="bk-public-modal__control">
                                                <QuestionTextbox
                                                  inline= {true}
                                                  question={question}
                                                  bookingStatus={''}
                                                  selectedAnswer={selectedAnswer}
                                                />
                                              </div>}
                                          </div>
                                        </div>
                                      )}})
                                    }
                                  </div>
                                )
                              }
                            })
                          }
                          </div>
                        </div>
                        }
                        <div className="bk-section">
                          <div className="bk-grid">
                            {object && object.attributes && object.attributes.start_project_expected_period && (
                            <div className="bk-field">
                              <FormGroup label={"How soon would you like to start?"} labelFor="bk-start-period">
                                <select
                                  id="bk-start-period"
                                  className='bk-input'
                                  placeholder={`Select `}
                                  onChange={this.onTimePeriodChange.bind(this)}
                                  defaultValue={attributes && attributes.start_project_expected_period}
                                >
                                  <option value="">Select one</option>
                                  {object && object.attributes && object.attributes.start_project_expected_period && object.attributes.start_project_expected_period.split(/\r?\n/).map((period) => {
                                    return(
                                      <option value={period.split(":")[1]}>{period.split(":")[0]}</option>
                                    )})}
                                </select>
                              </FormGroup>
                            </div>
                            )}
                            {object && object.attributes && object.attributes.contact_way && (
                            <div className="bk-field">
                              <FormGroup label={"How should we contact you?"} labelFor="bk-contact-way">
                                <select
                                  id="bk-contact-way"
                                  className='bk-input'
                                  placeholder={`Select `}
                                  onChange={this.onContactWayChange.bind(this)}
                                  defaultValue={attributes && attributes.contact_way}
                                >
                                  <option value="">Select one</option>
                                  {object && object.attributes && object.attributes.contact_way && object.attributes.contact_way.split(/\r?\n/).map((way) => {
                                    return(
                                      <option value={way.split(":")[1]}>{way.split(":")[0]}</option>
                                    )})}
                                </select>
                              </FormGroup>
                            </div>
                            )}
                          </div>
                        </div>
                        {object && object.attributes && object.attributes.enable_visit_us === true &&
                          <div className="bk-section">
                            <div className="bk-grid">
                              <div className="bk-field booking_form_date">
                                <FormGroup
                                  label={"When would you like us to visit?"}
                                  labelFor="text-input"
                                  labelInfo={"*"}
                                >
                                  <BookingDateTimeInput
                                    placeholder={'Pick a date'}
                                    onChange={this.handleStartDateChange.bind(this)}
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        }
                        {object && object.attributes && object.attributes.enable_often_visit_us === true &&
                          <div>
                          {frequency && frequency.length > 0 && <div className="bk-section">
                            <div className="bk-section__head">
                              <span className="bk-label">How often should we visit?</span>
                            </div>
                            <ChoiceGroup label="How often should we visit?" className="bk-pills">
                              {
                                frequency.map((freqncy, frequencyKey) => {
                                  return (
                                    <ChoiceCard
                                      key={freqncy.id || frequencyKey}
                                      className="bk-pill"
                                      checked={frequencyKey == this.state.isFrequencySelected}
                                      onSelect={(event) => { this.onFrequencySelect(event, freqncy, frequencyKey) }}
                                    >
                                      {freqncy.title}
                                    </ChoiceCard>
                                  )
                                })
                              }
                            </ChoiceGroup>
                          </div>}
                        </div>
                        }
                      </div>
                      : ''
                  }
                  {
                    bookingStep7 === true ?
                      <div className="bk-modal__step">
                        {object && object.attributes && object.attributes.payment_method === true &&
                          <div className="bk-section">
                            <div className="bk-section__head">
                              <span className="bk-label">Payment method</span>
                            </div>
                            <ChoiceGroup label="Payment method" className="bk-pills">
                              {
                                items.map((payment, paymentKey) => {
                                  // Hidden unless the company takes cards; indexes stay as they were.
                                  if (payment.value === CARD_PAYMENT_METHOD && !cardsOn) return null;
                                  return (
                                    <ChoiceCard
                                      key={payment.value}
                                      className="bk-pill"
                                      checked={paymentKey === this.state.isPaymentSelect}
                                      onSelect={(event) => { this.onPaymentSelect(event, payment, paymentKey) }}
                                    >
                                      {payment.label}
                                    </ChoiceCard>
                                  )
                                })
                              }
                            </ChoiceGroup>
                          </div>
                        }
                        {payByCard &&
                          <div className="bk-section">
                            <BookingCardPayment
                              stripeAccount={paymentSettings.stripe_account}
                              onReady={this.onCardReady}
                              onChange={this.onCardChange}
                              busy={this.isPaying}
                              error={this.paymentError}
                              amountLabel={charge ? `${currencyFormattedAmount(charge.charge)}${charge.taxLabel ? ` with ${charge.taxLabel}` : ''}` : null}
                              onRetry={awaitingPayment ? this.retryPayment.bind(this) : null}
                              retrying={this.isPaying}
                              charged={Boolean(this.paymentProgress.charged)}
                            />
                          </div>
                        }
                        <div className="bk-section">
                          <div className="bk-section__head">
                            <span className="bk-label">Photos or files <span className="bk-optional">Optional</span></span>
                          </div>
                          <div className="bk-upload">
                            <input id="file-upload" className="bk-upload__input" type="file" accept="image/*;capture=camera" multiple={true} onChange={this.onChangeFile.bind(this)} />
                            <label htmlFor="file-upload" className="bk-upload__drop">
                              <span className="bk-upload__icon"><Icon icon="cloud-upload" iconSize={18} /></span>
                              <span className="bk-upload__text">
                                <strong>Add a photo or file</strong>
                                <span>PNG, JPG, GIF, PDF, DOC, DOCX, XLS or XLSX, up to 10 MB</span>
                              </span>
                              {showUploadAttachmentLoader &&
                                <Spinner size={Spinner.SIZE_SMALL} />}
                            </label>
                          </div>
                          {attributes && attributes.booking_attachments.length > 0 &&
                            <ul className="bk-files">
                              {attributes.booking_attachments.map((attachment) => {
                                return (
                                  <li className="bk-file" key={attachment.id || attachment.asset.url}>
                                    <span className="bk-file__icon"><Icon icon="document" iconSize={14} /></span>
                                    <span className="bk-file__text">
                                      <a href={attachment.asset.url} target="_blank" rel="noopener noreferrer" download>{attachment.asset.url.split("/").pop()}</a>
                                      <span className="bk-file__meta">{attachment.asset_content_type}{attachment.asset_human_file_size ? `, ${attachment.asset_human_file_size}` : ''}</span>
                                    </span>
                                    <Button
                                      minimal={true}
                                      small={true}
                                      icon="trash"
                                      aria-label="Remove file"
                                      onClick={() => this.removeAttachment(attachment)}
                                    />
                                  </li>
                                )
                              })}
                            </ul>
                          }
                        </div>
                        <div className="bk-section">
                          <FormGroup label={"Note"} labelFor="bk-note" labelInfo={"Optional"}>
                            <textarea
                              id="bk-note"
                              type='text'
                              className='bk-input bk-input--area'
                              placeholder='Anything we should know before we arrive?'
                              defaultValue={attributes.note}
                              onChange={(event) => { attributes.note = event.target.value; }}
                            />
                          </FormGroup>
                        </div>
                      </div>
                      : ''
                  }
                </div>

                <div className="bk-modal__actions">
                  <Button
                    className="bk-btn bk-btn--back"
                    minimal={true}
                    icon="arrow-left"
                    disabled={(bookingStep && bookingStep === 1) || awaitingPayment || this.isPaying ? true : false}
                    onClick={this.navigateToPreviousScreen.bind(this)}
                    style={{ visibility: `${bookingStep && bookingStep === 1 ? 'hidden' : 'visible'}` }}
                    text="Back"
                  />
                  {bookingStep === 7 ?
                    <Button
                      className={attributes && attributes.status === 'confirmed' ? "bk-btn bk-btn--primary disable-confirm-btn" : "bk-btn bk-btn--primary"}
                      intent={Intent.PRIMARY}
                      onClick={this.createBooking.bind(this)}
                      loading={isLoading && !this.isPaying}
                      disabled={(attributes && attributes.status === 'confirmed') || this.isPaying ? true : false}
                      rightIcon="arrow-right"
                    >
                      {this.isPaying ? 'Paying…' : (awaitingPayment ? 'Try payment again' : confirmLabel)}
                    </Button>
                    :
                    <Button
                      className="bk-btn bk-btn--primary"
                      intent={Intent.PRIMARY}
                      onClick={this.navigateToNextScreen.bind(this)}
                      disabled={bookingStep && bookingStep === 7 ? true : false}
                      rightIcon="arrow-right"
                      text="Continue"
                    />
                  }
                </div>
              </div>

              <div className="bk-modal__aside">
                <aside className="bk-ticket" aria-label="Your quote request">
                  <div className="bk-ticket__when">
                    <span className="bk-ticket__date">{hasStartDate ? startDate.format('ddd, MMM D') : 'Date to be set'}</span>
                    {hasStartDate && <span className="bk-ticket__time">{startDate.format('h:mm A')}</span>}
                  </div>
                  <div className="bk-ticket__body">
                    {(customerName || (attributes && attributes.address)) &&
                      <div className="bk-ticket__row">
                        <span className="bk-ticket__icon"><Icon icon="person" iconSize={14} /></span>
                        <div className="bk-ticket__text">
                          <span className="bk-ticket__label">Your details</span>
                          {customerName && <span className="bk-ticket__value">{customerName}</span>}
                          {attributes && attributes.address &&
                            <span className="bk-ticket__muted">
                              {joinAddress(attributes.address, attributes.suite, attributes.city, attributes.state, attributes.zip)}
                            </span>
                          }
                        </div>
                      </div>
                    }
                    {selectedService ?
                      <div className="bk-ticket__service" style={selectedServiceColor ? { '--bk-service': selectedServiceColor } : undefined}>
                        <span className="bk-ticket__service-name">{selectedService.name}</span>
                        {showPrices && <span className="bk-ticket__muted">{`1 × ${currencyFormattedAmount(parseFloat(selectedService.rate))}`}</span>}
                        {showPrices && <span className="bk-ticket__amount">{currencyFormattedAmount(selectedService.rate)}</span>}
                      </div>
                      :
                      <p className="bk-ticket__empty">Choose a service to see your quote.</p>
                    }
                    {pricingLines.length > 0 &&
                      <div className="bk-modal__ticket-group">
                        <span className="bk-ticket__label">{pricingTitle}</span>
                        <ul className="bk-ticket__lines">
                          {pricingLines.map((parameter, lineKey) => {
                            return (
                              <li key={`p-${lineKey}`}>
                                <span>{parameter.name}</span>
                                <span className="bk-ticket__amount">{showPrices && tenantAttributes.enable_booking_pricing_parameter && currencyFormattedAmount((parameter.price))}</span>
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    }
                    {extraLines.length > 0 &&
                      <div className="bk-modal__ticket-group">
                        <span className="bk-ticket__label">Add-ons</span>
                        <ul className="bk-ticket__lines">
                          {extraLines.map((ext_service, lineKey) => {
                            return (
                              <li key={`e-${lineKey}`}>
                                <span>{ext_service.name}</span>
                                <span className="bk-ticket__amount">{showPrices && currencyFormattedAmount(ext_service.price)}</span>
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    }
                  </div>
                  {showPrices &&
                    <React.Fragment>
                      <div className="bk-ticket__tear" aria-hidden="true"></div>
                      <div className="bk-ticket__foot">
                        <div className="bk-ticket__total"><span>{totalLabel}</span><strong>{currencyFormattedAmount(attributes && attributes.total)}</strong></div>
                      </div>
                    </React.Fragment>
                  }
                </aside>
              </div>
            </div>
          </React.Fragment>
        }

        <div className="bk-modal__powered">Powered by <a href="https://fieldnexus.com/" target="_blank" rel="noopener noreferrer">Field Nexus</a></div>
      </Dialog>
    )
  }
}

export default BookingNewPublicModalPage;
